import angular from 'angular';
import { Usuario } from '../../../../core/usuario/models/usuario-model';
import { IContribuinteIndividualGet } from '../model/contribuintesindividuais.model';
import { IAnexo } from '../../Anexos/models/anexo.model';
import { MeurhContribuintesIndividuaisService } from '../contribuintesindividuais.service';
import { TiposDocumentosRequeridosService } from '../../../Tiposdocumentosrequeridos/tiposdocumentosrequeridos.service';
import { ModalConfirmService } from '../../../../shared/components/modal-confirm/modal.confirm.service';
import { MeurhSolicitacoes } from '../../Solicitacoes/services/solicitacoes.service';
import { WorkflowService } from '../../../Workflow/workflow.service';
import { ISolicitacao } from '../../Solicitacoes/models/solicitacao.model';

export class MeurhContribuintesIndividuaisShowController {

    static $inject = [
        '$rootScope',
        '$scope',
        '$state',
        '$stateParams',
        'entity',
        'MeurhContribuintesIndividuaisService',
        'TiposDocumentosRequeridosService',
        'MeurhSolicitacoes',
        'WorkflowService',
        'ModalConfirmService',
        'NewToaster',
    ];

    public busy = false;

    public formAnexo: angular.IFormController;
    public entityAnexo: IAnexo = {
        casodeuso: 'CONTRIBUINTEINDIVIDUAL'
    };
    public tiposdocumentosrequeridos: any[];
    public busyTipoDocumentos = false;

    constructor(
        public $rootScope: angular.IRootScopeService & {
            temPermissao: (arg: string) => boolean,
            liberadoTela: (arg: string) => boolean,
            usuario: Usuario,
            session: any,
        },
        public $scope: angular.IScope,
        public $state: angular.ui.IStateService,
        public $stateParams: angular.ui.IStateParamsService,
        public entity: IContribuinteIndividualGet,
        public MeurhContribuintesIndividuaisService: MeurhContribuintesIndividuaisService,
        public TiposDocumentosRequeridosService: TiposDocumentosRequeridosService,
        public MeurhSolicitacoes: MeurhSolicitacoes,
        public WorkflowService: WorkflowService,
        public ModalConfirmService: ModalConfirmService,
        public NewToaster: { pop: Function },
    ) {
        this.documentosAnexos();
        this.WorkflowService.config(
            this.entity.solicitacao,
            'meurh_solicitacoescontratacaocontribuinte_'
        );

        $scope.$on('meurh_tiposdocumentosrequeridos_list_finished', () => {
			this.busyTipoDocumentos = false;
			this.tiposdocumentosrequeridos = this.tiposdocumentosrequeridos.map((tipodocumentorequerido) => {
				tipodocumentorequerido.validateResult = false;
				tipodocumentorequerido.fileSelecionado = false;
				tipodocumentorequerido.file = '';
				return tipodocumentorequerido;
			});
		});

        $scope.$on('workflow_reloaded_after', () => {
            this.$state.reload();
        });
    }

    modalCancelar(entity: IContribuinteIndividualGet & ISolicitacao) {
        const customText = {
            title: 'Cancelar cadastro',
            subtitle: 'Você está prestes a cancelar o cadastro de autônomo de',
            confirmText: 'Após o cancelamento, não será possível desfazer. Deseja continuar?',
            confirmTextNum: entity.nome,
            closeButton: 'Voltar',
            confirmButton: 'Cancelar cadastro',
        };
        const confirm = this.ModalConfirmService.openCancelar(
            entity,
            'Solicitação de inclusão de autônomo',
            customText
        );
        confirm.result.then((entity: IContribuinteIndividualGet & ISolicitacao) => {
            this.cancelar(entity);
        }).catch(() => {/**/});
    }

    cancelar(entity: IContribuinteIndividualGet & ISolicitacao) {
        this.busy = true;
        this.MeurhSolicitacoes.cancelar(entity).then(() => {
            this.NewToaster.pop({
                type: 'success',
                title: 'A Solicitação de inclusão de autônomo foi cancelada com sucesso.'
            });
            this.$state.reload();
        }).catch((response: any) => {
            let error = 'Ocorreu um erro ao cancelar a solicitação de inclusão de autônomo.';
            if (response.data?.message) {
                error = response.data.message;
            }
            this.NewToaster.pop({
                type: 'error',
                title: error
            });
        }).finally(() => {
            this.busy = false;
        });
    }

    documentosAnexos() {
        const estabelecimento = this.entity.estabelecimento.estabelecimento;
        const casodeuso = 'CONTRIBUINTEINDIVIDUAL';
        this.setEntityAnexo({
            solicitacao: this.entity.solicitacao,
            casodeuso,
            estabelecimento
        });
        this.carregaTiposDocumentosRequeridos();
    }

    carregaTiposDocumentosRequeridos() {
        this.busyTipoDocumentos = true;
        this.resetTiposDocumentosRequeridosService();
        this.TiposDocumentosRequeridosService.constructors = {
            tiposolicitacao: this.entity.tiposolicitacao
        };
        this.tiposdocumentosrequeridos = this.TiposDocumentosRequeridosService.load();
    }

    resetTiposDocumentosRequeridosService() {
		this.TiposDocumentosRequeridosService.entities = [];
		this.TiposDocumentosRequeridosService.loadParams = {
			to_load: 3,
			busy: false,
			finished: false
		};
		this.TiposDocumentosRequeridosService.after = {};
	}

	setEntityAnexo(params: { solicitacao: string, casodeuso: string, estabelecimento: string }) {
        this.entityAnexo['estabelecimento'] = params.estabelecimento;
        this.entityAnexo['solicitacao'] = params.solicitacao;
        this.entityAnexo['casodeuso'] = params.casodeuso;
    }
}
